import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Phase 208c — Runtime app config exposed by the backend.
 *
 * Currently carries a single flag that toggles the demo / production behavior
 * for approved meetings:
 *   - lock_approved_meetings = false → demo (always editable)
 *   - lock_approved_meetings = true  → production (approved minutes locked)
 *
 * The config is fetched once on mount and cached for the session.
 */
const AppConfigContext = createContext({
  lockApprovedMeetings: false,
  loaded: false,
});

export function AppConfigProvider({ children }) {
  const [config, setConfig] = useState({ lockApprovedMeetings: false, loaded: false });

  useEffect(() => {
    axios
      .get(`${API}/app-config`)
      .then((r) => {
        setConfig({
          lockApprovedMeetings: !!r.data?.lock_approved_meetings,
          loaded: true,
        });
      })
      .catch(() => setConfig({ lockApprovedMeetings: false, loaded: true }));
  }, []);

  return <AppConfigContext.Provider value={config}>{children}</AppConfigContext.Provider>;
}

export function useAppConfig() {
  return useContext(AppConfigContext);
}
